import React from "react";
import { motion } from "framer-motion";
import { COGNITIVE_MODES } from "@/constants/modes";

export default function CognitiveModeSelector({ mode, onChange, disabled }) {
  return (
    <div className="flex items-center gap-1.5 p-1 rounded-full bg-black/40 border border-white/10" data-testid="cognitive-mode-selector">
      {COGNITIVE_MODES.map((m) => {
        const active = mode === m.id;
        return (
          <button
            key={m.id}
            data-testid={`mode-option-${m.id}`}
            disabled={disabled}
            onClick={() => onChange(m.id)}
            className="relative px-3 py-1.5 rounded-full text-[10px] font-mono-data uppercase tracking-wider transition-colors duration-300 disabled:opacity-50"
            style={{ color: active ? "#030509" : "#94A3B8" }}
          >
            {active && (
              <motion.div
                layoutId="mode-pill"
                className="absolute inset-0 rounded-full"
                style={{ backgroundColor: m.color, boxShadow: `0 0 16px ${m.color}88` }}
                transition={{ type: "spring", stiffness: 300, damping: 26 }}
              />
            )}
            <span className="relative z-10">{m.short}</span>
          </button>
        );
      })}
    </div>
  );
}
